export default {"src":"/_next/static/media/pub-restaurant-icon-selected.129cb6f9.svg","height":70,"width":80,"blurWidth":0,"blurHeight":0};